var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-carousel',{staticClass:"mt-3",attrs:{"cycle":""}},_vm._l((_vm.items),function(item,i){return _c('v-carousel-item',{key:i,attrs:{"src":item.src,"reverse-transition":"fade-transition","transition":"fade-transition"}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }